<template>
  <div :class="['question-inset-box', 'box', { standalone: isStandalone }]">
    <div
      class="flex items-center p-4 justify-between"
      :class="{
        'px-0': isStandalone,
      }"
    >
      <JoszakiHeading :level="2">
        <slot>
          {{ $t("questionsPage.inset.title") }}
        </slot>
      </JoszakiHeading>
      <IconComponent
        v-if="showClose"
        icon="times"
        class="pointer"
        @click.native="close"
      />
    </div>
    <div class="p-4 text-sm lg:text-lg">
      <slot name="subtitle" />
    </div>
    <div>
      <QuestionInset
        v-for="question in questions"
        :key="question.id"
        :show-close="showClose"
        :show-answer-button="showAnswerButton"
        :question="question"
        :is-standalone="isStandalone"
        @close="emitQuestionClosed"
      />
    </div>
    <div class="flex justify-center action-row">
      <NuxtLink
        v-if="action.href"
        :to="action.href"
        class="button is-strong"
        @click="$trackers.trackClick('QuestionInsetBoxAction')"
      >
        {{ action.text || $t("questionsPage.inset.action") }}
      </NuxtLink>
    </div>
  </div>
</template>

<script>
import QuestionInset from "~/components/QuestionInset";

export default {
  components: { QuestionInset },
  props: {
    questions: {
      type: Array,
      default() {
        return [];
      },
    },
    action: {
      type: Object,
      default() {
        return {
          text: null,
          href: null,
        };
      },
    },
    isStandalone: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    showAnswerButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitQuestionClosed(questionId) {
      this.$emit("questionClosed", questionId);
    },
    close() {
      this.$trackers.trackClick("QuestionInsetBoxClose");
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:math";
@use "styles/_all-members" as global;

$spacing: 10px;

.question-inset-box {
  border-radius: 1rem;
  padding: $spacing ($spacing * 2.5);
  background: white;

  @include global.mobile {
    padding: math.div($spacing, 2) 0;
  }

  &.standalone {
    padding: 0;
    box-shadow: none;
    background: transparent;

    .action-row {
      padding-top: $spacing * 2.5;
    }
  }
}
.action-row {
  justify-content: center;
}
</style>
